import React from 'react';
import {
  Divider,
  Stack,
  DialogTitle,
  Box,
  Typography,
  IconButton,
  DialogContent,
} from '@mui/material';
import { BulkEditField, SelectFieldDialogProps } from '../constants';
import { OptionsList } from '@components/OptionsList';
import CloseIcon from '@mui/icons-material/Close';
import { useBulkEdit } from '../context';
import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import { ModalSheetDialog as Dialog } from './styledComponents';

export const SelectField = ({
  open,
  fieldOptions,
  onCancel,
  onSelectField,
}: SelectFieldDialogProps) => {
  const flags = useLDFlags();
  
  const handleFieldSelection = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value as BulkEditField;
    onSelectField(value);
  };

  const { getHeaderText } = useBulkEdit();

  // Only show the options enabled by the feature flag
  const enabledOptions = fieldOptions.filter(
    option =>
      !flags.releaseBulkEditFields ||
      flags.releaseBulkEditFields.includes(option.id)
  );

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="lg"
      sx={{ pt: 2, pb: 2 }}
      data-testid="select-field-dialog"
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pt={1}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="h3">{getHeaderText()}</Typography>
          </Box>

          <IconButton onClick={onCancel} size="large" aria-label="close">
            <CloseIcon data-testid="CloseIcon" />
          </IconButton>
        </Box>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={3}>
          <OptionsList
            options={enabledOptions}
            onChange={handleFieldSelection}
          />
          <Divider />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
